module.exports = __webpack_public_path__ + "img/group-icon.76941f28.png";